import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
  }
`;

export const Container = styled.div`
  padding: 24px 16px 124px;
  width: 100%;
  height: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  @media ${({ theme }) => theme.queries.minTablet} {
    height: auto;
    padding: 48px 64px 64px;
  }
`;
export const FeedbackHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;
